$(document).ready(function(){
   let path = window.location.pathname; 
   let pageName = path.replace(/\/$/, "").split("/").pop();
   let $artist_location = $(".artist-page-h2-location");
   
   switch (pageName) {
    case 'artists':
    case 'piercers':
        $artist_location.html("SHOP");
        $(".all-artists").addClass("active");
        break;

    case 'north-artists':
    case 'north-piercers':
        $artist_location.html("NORTH SHOP");
        $(".north-artists-btn").addClass("active");
        break;

    case 'gulf-gate-artists':
        case 'gulf-gate-piercers':
        $artist_location.html("GULF GATE");
        $(".gulf-gate-artists-btn").addClass("active");
        break;

    case 'venice-artists':
        case 'venice-piercers':
        $artist_location.html("VENICE");
        $(".venice-artists-btn").addClass("active");
        break;

    default:
        break;
   }

      var screenWidth = $(window).width();

  if (screenWidth > 768) {
          var swiper = new Swiper(".mySwiper", {
      slidesPerView: 5,
      centeredSlides: false,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

      var swiper = new Swiper('.mySwiper-onlocation', {
    slidesPerView: 5,
    spaceBetween: 40,
    loop:false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  }

});